import { useMemo } from 'react'
import { useSelector } from 'react-redux'

const hasAnyWorkPlaces = (node) => {
	const groups = node?.positionGroups ?? []
	return groups.some((g) => (g?.workPlaces ?? []).length > 0)
}

/**
 * Подсвечиваем узел, если:
 * - у него есть workPlaces
 * - или хотя бы у одного потомка есть workPlaces (т.е. ветка "содержит" workPlaces)
 */
const buildHighlightSetFromApi = (apiRoots = []) => {
	const set = new Set()

	const walk = (node) => {
		if (!node) return false

		const selfHas = hasAnyWorkPlaces(node)
		const childHas = (node?.child ?? []).some((ch) => walk(ch))
		const subtreeHas = selfHas || childHas

		if (subtreeHas && node?.code) {
			set.add(node.code)
		}

		return subtreeHas
	}

	;(apiRoots ?? []).forEach((root) => walk(root))
	return set
}

export const useHighlightMatch = (code) => {
	const targetDeptCodes = useSelector((state) => state.staffing.targetDeptCodes)
	const apiData = useSelector((state) => state.staffing.deptSearch?.data)

	const highlightSet = useMemo(() => {
		// базовая подсветка по кодам из ответа
		const base = new Set(targetDeptCodes || [])

		// + подсветка родителей только по веткам, где есть workPlaces
		const byWorkPlacesTree = buildHighlightSetFromApi(apiData || [])
		byWorkPlacesTree.forEach((c) => base.add(c))

		return base
	}, [targetDeptCodes, apiData])

	return !!code && highlightSet.has(code)
}
